import * as React from "react";
import { FitnessPrescriptionItemRequest, PrescriptionItemGuideline } from "@curefit/gmf-common";
import {default as AppUtils, EpochConstants, LOADING_STATE} from "../../utils/AppUtils"
import EditViewCard, {EditViewDisplayMode} from "../../components/common/EditViewCard"
import AppLoader from "../../components/utils/AppLoader"
import * as _ from "lodash"
import ModelFactory from "../../models/ModelFactory"
import IEditedBy from "../../models/IEditedBy";
import {AdherenceCategories, AppConstants} from "../../utils/AppConstants";
import {FitnessPlanEditorProps} from "../../components/patient/edit/FitnessPlanEditor";
import {PatientFitnessPlansViewProps} from "../../components/patient/view/PatientFitnessPlansView";
import {IFitnessPlanData, IPlanActivity} from "../../models/LCPlanClientModels";

/**
 * Created by aditya on 28/02/18.
 */



export interface FitnessPlanEditViewContProps {
    editedBy: IEditedBy,
    patientId: number,
    secondaryPatientId: string,
    patientFitnessPlans: IFitnessPlanData,
    displayMode?: EditViewDisplayMode,
    fetchPatientFitnessPlan?: (patientId: number) => any,
    savePatientFitnessPlan?: (patientId: number, patientFitnessPlans: FitnessPrescriptionItemRequest[]) => any
    fetchFitnessActivities?: (input: string) => Promise<any>;
    isSelf: boolean;
    consultationId: number;
    doctorId: number;
    doctorType: string;
    doctorName: string;
    cardTitleDisplay?: string
}

export interface FitnessPlanEditViewContState {
    updatedFitnessPlans: {item: IPlanActivity}[],
    isPatientFitnessPlanDataLoaded: LOADING_STATE,
    updatedFitnessGuidelines: {item: string}[]
}

class FitnessPlanEditViewCont extends React.Component<FitnessPlanEditViewContProps, FitnessPlanEditViewContState> {

    constructor(props: FitnessPlanEditViewContProps) {
        super(props);
        this.state = this.getStateFromProps(props);
    }

    componentWillReceiveProps(props: FitnessPlanEditViewContProps) {
        this.setState(this.getStateFromProps(props));
    }

    getStateFromProps = (props: FitnessPlanEditViewContProps) => {
        let currState: FitnessPlanEditViewContState = {
            updatedFitnessPlans: [],
            isPatientFitnessPlanDataLoaded: LOADING_STATE.NOT_INITIALIZED,
            updatedFitnessGuidelines: []
        }
        if ( _.isNull(props.patientFitnessPlans) ) {
            props.fetchPatientFitnessPlan(this.props.patientId);
            currState.isPatientFitnessPlanDataLoaded = LOADING_STATE.LOADING;
        } else {
            if (!_.isEmpty(props.patientFitnessPlans)) {
                const activities = props.patientFitnessPlans.activities || [];
                const guidelines = props.patientFitnessPlans.guidelines || [];
                currState.updatedFitnessPlans = _.map(activities, (activity: IPlanActivity) => ({item: activity}));
                currState.updatedFitnessGuidelines = _.map(guidelines, (guideline: string) => ({item: guideline}));
            }
            currState.isPatientFitnessPlanDataLoaded = LOADING_STATE.LOADED;
        }
        return currState;
    }

    getConcernEditViewTemplateProps = () => {
        let patientFitnessPlanViewProps: PatientFitnessPlansViewProps = {
            patientFitnessPlans: this.props.patientFitnessPlans
        }
        let patientFitnessPlanEditorProps: FitnessPlanEditorProps = {
            fetchFitnessActivities: this.props.fetchFitnessActivities,
            updatedFitnessPlans: this.state.updatedFitnessPlans,
            updateFitnessPlans: this.updatePatientFitnessPlan,
            updatedFitnessGuidelines: this.state.updatedFitnessGuidelines,
            updateFitnessPlanGuidelines: this.updateFitnessGuidelines,
            consultationId: this.props.consultationId,
            doctorId: this.props.doctorId,
            doctorType: this.props.doctorType,
            doctorName: this.props.doctorName
        }
        return {"view": patientFitnessPlanViewProps, "edit": patientFitnessPlanEditorProps};
    }

    updatePatientFitnessPlan = (updatedFitnessPlans: {item: IPlanActivity}[]) => {
        this.setState({updatedFitnessPlans});
    }

    updateFitnessGuidelines = (updatedFitnessGuidelines: { item: string }[]) => {
        this.setState({ updatedFitnessGuidelines })
    }

    savePatientFitnessPlan = () => {
        let myInstance = this;
        let fitnessPrescription: FitnessPrescriptionItemRequest[] = this.getSaveObject();
        // if (ModelFactory.isValidFitnessPrescriptionItem(fitnessPrescription)) {
            this.setState({isPatientFitnessPlanDataLoaded: LOADING_STATE.NOT_INITIALIZED})
            this.props.savePatientFitnessPlan(this.props.patientId, fitnessPrescription).then(function(){
                myInstance.setState({isPatientFitnessPlanDataLoaded: LOADING_STATE.LOADED})
            });
        // }
    }

    cancelActionHandler = () => {
        // this.setState({updatedFitnessPlans: this.getUpdatedConcernsFromProps(this.props)});
    }

    isFormDirty = (): boolean => {
        let status = false;
        let erronousRows: number[] = [];
        _.map(this.state.updatedFitnessPlans, function(updatedFitnessPlanItem: {item: IPlanActivity}, index: number){
            if (!ModelFactory.isValidFitnessPrescriptionItem(updatedFitnessPlanItem.item)) {
                status = true;
                erronousRows.push(index + 1);
                return false;
            }
        })
        return status;
    }

    dirtyFormText = (): string => {
        let erronousRows: any[] = [];
        _.map(this.state.updatedFitnessPlans, function(updatedFitnessPlanItem: {item: IPlanActivity}, index: number){
            if (!ModelFactory.isValidFitnessPrescriptionItem(updatedFitnessPlanItem.item)) {
                erronousRows.push({index: index + 1, erroneousCol: ModelFactory.getPlanActivityEmptyCol(updatedFitnessPlanItem.item)});
                return false;
            }
        })
        if (!_.isEmpty(erronousRows)) {
            const errorTexts: string[] = erronousRows.map((rowItem) => `${rowItem.erroneousCol} in row ${rowItem.index}`)
            let errorText = `Missing ${errorTexts.join(", ")}`;
            return errorText;
        }
        return null
    }

    getSaveObject = (): IFitnessPlanData => {
        let fitnessPrescriptionList: IPlanActivity[] = _.map(this.state.updatedFitnessPlans, (updatedFitnessPrecriptionItem: {item: IPlanActivity}) => updatedFitnessPrecriptionItem.item);

        /* FOR GUIDELINES FITNESS PRESCRIPTION ITEM */
        let updatedGuidelinesList = this.state.updatedFitnessGuidelines.map((guideline: {item: string}) => guideline.item);

        return {
            activities: fitnessPrescriptionList,
            guidelines: updatedGuidelinesList,
            referenceId: this.props.consultationId.toString()
        };
    }

    render() {
        let isConcernDataLoaded =  this.state.isPatientFitnessPlanDataLoaded === LOADING_STATE.LOADED;
        return (
            <div className="fitness-plan-editview-cont">
                {
                    isConcernDataLoaded &&
                    <EditViewCard cardTitleDisplay={this.props.cardTitleDisplay || "Fitness Plan"} templateName={"fitnessPlan"}
                                  templateProps={this.getConcernEditViewTemplateProps()}
                                  lastEditedEpoch={new Date().getTime()} saveActionHandler={this.savePatientFitnessPlan}
                                  cancelActionHandler={this.cancelActionHandler}
                                  displayMode={this.props.displayMode} />
                }
                {
                    !isConcernDataLoaded &&
                    <AppLoader/>
                }
            </div>
        );
    }
}

export default FitnessPlanEditViewCont